export default __webpack_public_path__ + "static/media/phone.3a8148f9.svg";